export { ShoppingBag as default } from './ShoppingBag';
